// Cor do status da iniciativa SWOT (valores gravados em swot.initiative.status)
export function initiativeStatusColor(status) {
    switch (status) {
        case 'Concluído': return 'green';
        case 'Em andamento': return 'blue';
        case 'Cancelado': return 'red';
        default: return 'grey';
    }
}
